import React from 'react';

export const RadioGroup = ({ label, options, value, onChange, className = "" }) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {label && <label className="text-xs font-semibold text-brand-muted uppercase tracking-wider">{label}</label>}
      <div className="flex flex-wrap gap-3">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`flex-1 min-w-[100px] px-4 py-2.5 rounded-lg border text-sm font-medium transition-all duration-200 
              ${value === option.value 
                ? 'border-brand-accent bg-brand-accent/10 text-brand-accent ring-1 ring-brand-accent' 
                : 'border-brand-border bg-white text-brand-muted hover:border-brand-accent/50'}`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};